import React from 'react';
import { connect } from 'react-redux';

import { db, firebase } from '../../firebase';
import { loadStore } from 'store/actions/loader';

const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authUser: null,
      };
    }

    componentDidMount() {
      const { onSetAuthUser } = this.props;

      firebase.auth.onAuthStateChanged(authUser => {
        if (authUser) {
          db.getUserOrganizations(authUser.uid)
            .then(snapshot => {
              const organizations = [];
              snapshot.forEach(childSnapshot => {
                const organization = { id: childSnapshot.key, ...childSnapshot.val() };
                organizations.push(organization);
              });

              const organization = organizations[0];
              firebase.setOID(organization.id);
              onSetAuthUser(authUser, organization);
              loadStore();
            });
        } else {
          onSetAuthUser(null, null);
        }
      });
    }

    render() {
      return (
        <Component />
      );
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    onSetAuthUser: (authUser, organization) => dispatch({ type: 'AUTH_USER_SET', authUser, organization }),
  });

  return connect(null, mapDispatchToProps)(WithAuthentication);
}

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/components/auth/withAuthentication.js